import {Row, Col, Container, PureGridProvider} from './3rdparty/react-pure-grid';
import Icon from 'react-icons-kit';

import {chevronRight} from 'react-icons-kit/fa/chevronRight'
import {chevronLeft} from 'react-icons-kit/fa/chevronLeft'
import {percent} from 'react-icons-kit/fa/percent'
import {envelopeO} from 'react-icons-kit/fa/envelopeO'
import {phone} from 'react-icons-kit/fa/phone'
import {mapMarker} from 'react-icons-kit/fa/mapMarker'
import {clockO} from 'react-icons-kit/fa/clockO'
import {hotel} from 'react-icons-kit/fa/hotel'
import {calendar} from 'react-icons-kit/fa/calendar'
import {ticket} from 'react-icons-kit/fa/ticket' 
import {facebookOfficial} from 'react-icons-kit/fa/facebookOfficial'
import {linkedin} from 'react-icons-kit/fa/linkedin'
import {instagram} from 'react-icons-kit/fa/instagram'
import {briefcase} from 'react-icons-kit/fa/briefcase'
import {map} from 'react-icons-kit/fa/map'
import {calendarCheckO} from 'react-icons-kit/fa/calendarCheckO'

import {ic_access_time}  from 'react-icons-kit/md/ic_access_time';
import {ic_directions_walk}  from 'react-icons-kit/md/ic_directions_walk';
import {ic_directions_car}  from 'react-icons-kit/md/ic_directions_car';
import {ic_record_voice_over} from 'react-icons-kit/md/ic_record_voice_over';
import {ic_headset} from 'react-icons-kit/md/ic_headset';

import { layoutGenerator } from 'react-break';
import { Tooltip } from 'react-tippy';
import SlickSlider from "react-slick";
import Zoom from 'react-reveal/Zoom';
import Fade from 'react-reveal/Fade';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import "react-tabs/style/react-tabs.css";
import Grid from '@material-ui/core/Grid';
import ShowMoreText from 'react-show-more-text';

import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import TextField from "material-ui/TextField";
import RaisedButton from "material-ui/RaisedButton";
import DatePicker from "material-ui/DatePicker";
import Dialog from "material-ui/Dialog";

import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"

import markdown from './services/markdown'

import { NavLink, Link } from 'react-router-dom';
import Utils from './services/utils';

const maIcons = {
  ic_access_time, ic_directions_walk, ic_directions_car, ic_record_voice_over, ic_headset
}

const faIcons = {chevronRight, chevronLeft, percent, envelopeO, phone, mapMarker, clockO, hotel, calendar, ticket, facebookOfficial, linkedin, instagram, briefcase, map, calendarCheckO};

const layout = layoutGenerator({
  mobile: 0,
  phablet: 768,
  tablet: 992,
  desktop: 1200,
});


// lg: {
//   browser: 1200,
//   container: 1170
// },
// md: {
//   browser: 992,
//   container: 870
// },
// sm: {
//   browser: 768,
//   container: 750
// },
// xs: {
//   browser: 0,
//   container: 'auto'
 
const OnMobile = layout.is('mobile');
const OnPhablet = layout.is('phablet');
const OnTablet = layout.is('tablet');
const OnAtLeastPhablet = layout.isAtLeast('phablet');
const OnAtLeastTablet = layout.isAtLeast('tablet');
const OnAtMostTablet = layout.isAtMost('tablet');
const OnAtMostPhablet = layout.isAtMost('phablet');
const OnDesktop = layout.is('desktop');


export default {
    Row, Col, Container, PureGridProvider,
    Icon,
    faIcons,
    maIcons,
    OnMobile,
    OnAtLeastPhablet,
    OnAtLeastTablet,
    OnAtMostTablet,
    OnAtMostPhablet,
    OnDesktop,
    OnPhablet,
    OnTablet,
    Tooltip,
    SlickSlider,
    markdown,
    NavLink,
    Link,
    Utils,
    SelectField,
    MenuItem,
    TextField,
    RaisedButton,
    DatePicker,
    Dialog,
    Fade,
    Zoom,
    GoogleMap,
    Marker,
    Tab, 
    Tabs, 
    AppBar,
    Grid,
    ShowMoreText
  }